import BaseService from '@src/services/BaseService'
import * as storeFile from "@state/store";

class CheckinCheckoutPhotoReportService extends BaseService {
    constructor() {
        super('checkin-checkout-photo-reports')
    }

    getUrl() {
        return `${process.env.VUE_APP_API_ENDPOINT}/${this.filterTenant ? `tenant/${storeFile.default.getters['auth/tenantId']}/` : ''}${this.urlRoute}`
    }
}

export default new CheckinCheckoutPhotoReportService()
